<template>
  <router-link
    :to="link"
    class="brand__store P-m BDRS-m"
  >
    <div
      v-if="selectedFinderMode === 'AREA'"
      class="store-icon MR-s BDRS-100 BGC-light C-grey"
    >
      <div class="icon"><span class="material-icons-round">store</span></div>
    </div>
    <div
      v-else
      class="store-icon MR-s BDRS-100 BGC-light C-grey"
    >
      <div class="icon"><span class="material-icons-round">place</span></div>
      <div class="distance">{{ parseDistance(store.distance) }}</div>
    </div>
    <div class="meta">
      <div class="store-name MB-xs FW-b">{{ store.name }}</div>
      <div class="store-desc C-grey FZ-14">
        {{ store.address }}<br>{{ store.desc }}
      </div>
      <div class="store-service MT-xxs FZ-12 LH-140 C-grey">
        <template v-if="store.delivery">
          <div
            class="store-service-pill MR-xxs PT-xxs PR-xs PB-xxs PL-xs D-ib BDRS-99 BGC-brand FW-b C-dark"
            :class="{ 'is-scheduled': store.delivery === 'SCHEDULED', 'is-unavailable': store.delivery === 'UNAVAILABLE' }"
          >{{ $t('home.delivery') }}</div>{{ parseServiceStatus(store.delivery) }}
        </template>
        <template v-if="store.pickup">
          <div
            class="store-service-pill MR-xxs PT-xxs PR-xs PB-xxs PL-xs D-ib BDRS-99 BGC-brand FW-b C-dark"
            :class="{ 'is-scheduled': store.pickup === 'SCHEDULED', 'is-unavailable': store.pickup === 'UNAVAILABLE' }"
          >{{ $t('home.pickup') }}</div>{{ parseServiceStatus(store.pickup) }}
        </template>
      </div>
    </div>
    <div class="brand__arrow ML-s C-light-grey">
      <span class="material-icons-round">chevron_right</span>
    </div>
  </router-link>
</template>

<script>
import parseServiceStatus from '@/helpers/parse-service-status';

export default {
  props: {
    store: {
      type: Object,
      default: () => {},
    },
    selectedFinderMode: {
      type: String,
      default: 'AREA',
    },
  },
  computed: {
    link() {
      return {
        name: 'Store',
        params: {
          brandId: this.store.brand_id,
          storeId: this.store.token,
          ...this.$route.params,
        },
        query: {
          ...this.$route.query,
        },
      };
    },
  },
  methods: {
    parseServiceStatus,
    parseDistance(distance) {
      if (!distance) {
        return '0m';
      }

      if (distance < 1) {
        return `${distance.toFixed(3) * 1000}m`;
      }

      if (distance < 10) {
        return `${distance.toFixed(2)}km`;
      }

      if (distance < 50) {
        return `${distance.toFixed(1)}km`;
      }

      return `${distance.toFixed(0)}km`;
    },
  },
};
</script>

<style lang="sass" scoped>
.brand__store
  position: relative
  display: flex
  flex-direction: row
  align-items: center
  color: #333
  cursor: pointer
  text-decoration: inherit

  &:active, &:hover
    background-color: transparentize($color-light, .5)
    &::before, & + .brand__store::before
      background-color: transparent

  &::before
    content: ''
    position: absolute
    top: 0
    left: 16px
    right: 16px
    height: 1px
    background-color: $color-light

    @media only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi)
      height: .5px
      background-color: $color-light-grey

  &:first-child::before
    height: 0
    background-color: transparent

  .store-icon
    width: 64px
    min-width: 64px
    height: 64px
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center

    .icon
      width: 24px
      height: 24px

  .distance
    font-size: 10px

  .meta
    flex-grow: 1

  .store-service-pill
    border: 1px solid $color-brand

    @media only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi)
      border-width: .5px

    &.is-scheduled
      background-color: white

    &.is-unavailable
      border: 1px solid $color-light-grey

      background-color: white

      @extend .C-grey

      @media only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi)
        border-width: .5px

    &:nth-child(2)
      @extend .ML-s
</style>
